/**
 * @fileoverview AR-805 — teacher's on-demand submission import for a project
 * (POST .../google_classroom_course/sync_submissions). The same import runs by
 * itself every 15 min on the backend cron; this only makes it immediate.
 */

import { useCallback, useState } from 'react'

import { getClassroomAdapters } from '../provider'
import { SubmissionsSyncSummary } from '../phase3Types'

export interface ClassroomSyncState {
  syncing: boolean
  lastResult: SubmissionsSyncSummary[] | null
  syncSubmissions: (projectId: string) => Promise<SubmissionsSyncSummary[]>
}

/** Newly imported submissions across every assignment of the project. */
export function totalImported(assignments: SubmissionsSyncSummary[]): number {
  return assignments.reduce((total, assignment) => total + assignment.summary.imported, 0)
}

export function useClassroomSync(): ClassroomSyncState {
  const [syncing, setSyncing] = useState(false)
  const [lastResult, setLastResult] = useState<SubmissionsSyncSummary[] | null>(null)

  const syncSubmissions = useCallback(async (projectId: string) => {
    setSyncing(true)
    try {
      const result = await getClassroomAdapters().submissionSync.syncSubmissions(projectId)
      setLastResult(result)
      return result
    } finally {
      setSyncing(false)
    }
  }, [])

  return { syncing, lastResult, syncSubmissions }
}
